import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { setSelectedMember, clearSelectedMember } from '@/store/authSlice';
import { RootState } from '@/store';
import { useManagedMembersContext } from '@/context/ManagedMembersContext';
import { setNavigationSource } from '@/utils/navigationSource';
import FamilyOverview from './FamilyOverview';

const EmergencyCardsOverview: React.FC = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const loggedInMember = useSelector((state: RootState) => state.auth.member);
  const { managedMembers } = useManagedMembersContext();

  // Clear selectedMember when overview screen loads
  useEffect(() => {
    dispatch(clearSelectedMember());
    localStorage.removeItem('selectedMember');
  }, [dispatch]);

  const handleMemberAction = (memberId: string, action: string) => {
    // Find the member object from managedMembers
    const member = managedMembers.find(m => m.id === memberId);
    
    // Set selectedMember in localStorage
    if (member) {
      localStorage.setItem('selectedMember', JSON.stringify(member));
      
      // Update selectedMember in Redux (like profile picker does)
      if (member.id === loggedInMember?.id) {
        dispatch(clearSelectedMember());
      } else {
        dispatch(setSelectedMember(member));
      }
    }

    if (action === 'view' || action === 'manage') {
      // Set navigation source to current overview page
      setNavigationSource('overview', window.location.pathname);
      console.log(action)
      if (action === 'view') {
        // Navigate to view emergency card for this member (when card is complete)
        navigate('/dashboard/emergency-card', { state: { memberId, backUrl: window.location.pathname } });
      } else {
        // Navigate to activate/manage emergency card (when card is not complete)
        navigate('/profile/emergency-card/activate', { state: { memberId, backUrl: window.location.pathname } });
      }
    }
  };

  return <FamilyOverview type="emergency-cards" onMemberAction={handleMemberAction} />;
};

export default EmergencyCardsOverview;
